import React from "react";

import { SelectPlan } from "app/plans";
import { Navigate, Route } from "react-router-dom";
import {
  BigCommerceInstall,
  BigCommerceLoad,
  GeneratePassword,
  Install,
  LinkRegister,
  Login,
  PreLogin,
  Redirect,
  Register,
  RegisterSeller,
  ResendVerifyEmail,
  ResetPassword,
  ResetPasswordConfirmation,
  // // SellerShopify,
  ShopifyPayment,
  VerifyEmail,
  WooCommerceInstall,
  WooCommerceLoad,
  SingularPrivacy,
  SingularTerms,
  SingularSITerms,
  SingularSIPrivacy,
  SingularHUPrivacy,
  SingularHUTerms,
  SeurPrivacy,
  SeurTerms,
  HRPrivacy,
  HRTerms,
  XhawiPrivacy,
  XhawiTerms,
  XhawiRefundPolicy,
} from "app/public";
import NotFound from "layout/private/components/notFound/notFound";

import PublicRoute from "./publicRoute";

const routes = [
  { path: "/bigcommerce/install", element: <BigCommerceInstall /> }, // not opened without login or with login
  { path: "/bigcommerce/load", element: <BigCommerceLoad /> },
  { path: "/join/:id/:shop", element: <LinkRegister /> },
  { path: "/login", element: <Login /> }, // done
  { path: "/prelogin", element: <PreLogin /> }, // done
  { path: "/register", element: <Register /> }, // done
  { path: "/register/role", element: <Navigate to="/register/seller" replace /> },
  { path: "/register/seller", element: <RegisterSeller /> }, // done
  { path: "/resend-verify-email", element: <ResendVerifyEmail /> }, // done
  { path: "/reset-password", element: <ResetPassword /> }, // done
  { path: "/reset-password/:token", element: <ResetPasswordConfirmation /> },
  { path: "/shopify/install", element: <Install /> },
  { path: "/shopify/redirect", element: <Redirect /> },
  { path: "/shopify/plan", element: <SelectPlan /> }, // setback
  { path: "/seller/shopify", element: <NotFound /> }, // doesnt work
  { path: "/shopify/payment", element: <ShopifyPayment /> }, // done
  { path: "/verify-email/:token", element: <VerifyEmail /> },
  { path: "/otp", element: <GeneratePassword /> }, // done
  { path: "/woocommerce/install", element: <WooCommerceInstall /> }, // done
  { path: "/woocommerce/load", element: <WooCommerceLoad /> }, // not opens
  { path: "/singular/privacy", component: SingularPrivacy },
  { path: "/singular/term", component: SingularTerms },
  { path: "/singular/si/term", component: SingularSITerms },
  { path: "/singular/si/privacy", component: SingularSIPrivacy },
  { path: "/singular/hu/term", component: SingularHUTerms },
  { path: "/singular/hu/privacy", component: SingularHUPrivacy },
  { path: "/xhawi/privacy", component: XhawiPrivacy },
  { path: "/xhawi/term", component: XhawiTerms },
  { path: "/xhawi/refund", component: XhawiRefundPolicy },
  { path: "/seur/privacy", component: SeurPrivacy },
  { path: "/seur/term", component: SeurTerms },
  { path: "/hr/privacy", component: HRPrivacy },
  { path: "/hr/term", component: HRTerms },
];

const publicRoutes = routes.map(({ path, element }) => ({ path, element: <PublicRoute>{element}</PublicRoute> }));
// const publicRoutes = routes.map(({ path, element }) => (
//   <Route
//     key={path}
//     path={path}
//     element={<PublicRoute>{element}</PublicRoute>}
//   />
// ));
export default publicRoutes;
